import axios from "axios";
import Vue from "vue";

//const URL = 'https://smapi.sundryhrms.website/api/'
// const URL = 'http://127.0.0.1:8000/api/'
// const URL = 'https://sundryfoods.website/api/'
const URL = "https://sundrymarkets.website/api/";
export default {
  name: "Request",

  makeGetRequest: (request) => {
    Vue.prototype.$swal.close();

    if (request.showLoader || request.showLoader == undefined) {
      var loading_html =
        '<div style="height:150px;width:150px;margin:0 auto;display:flex;align-items:center;justify-content:center;">' +
        '<div style="' +
        "width:60px;height:60px;" +
        "border:6px solid #ccc;" +
        "border-top:6px solid #F8A022;" +
        "border-radius:50%;" +
        "animation:spin 0.8s linear infinite;" +
        '"></div>' +
        "</div>" +
        "<style>" +
        "@keyframes spin {" +
        "to { transform: rotate(360deg); }" +
        "}" +
        "</style>";

      Vue.prototype.$swal.fire({
        title: "",
        html: loading_html,
        showConfirmButton: false,
        showCancelButton: false,
      });
    }

    var request_urls = {
      openings: "openingsallWelcome",
      SearchJobs: "openings",
      Companies: "companylocations",
      openings2: "listopenings",
    };

    if (request.params !== undefined) {
      var obj = request.params;
      var str = Object.keys(obj)
        .map((key) => {
          return key + "=" + obj[key];
        })
        .join("&");
      var request_url = URL + request_urls[request.what] + "?" + str;
    } else {
      //var request_url = URL + request_urls[request.what]
      if (request.url == undefined) {
        var request_url = URL + request_urls[request.what];
      } else {
        var request_url = request.url;
      }
    }
    console.log(
      "%cSending get request to: " + "%c" + request_url,
      "color:#00ff00;font-size:14px;background:#000;",
      "color:#ff0000;font-size:14px;background:#000;",
    );
    return new Promise((resolve, reject) => {
      axios
        .get(request_url)
        .then((response) => {
          Vue.prototype.$swal.close();
          if (
            response.data.status == "True" ||
            response.data.status == true ||
            response.data.status == "true"
          ) {
            var response = {
              data: response.data.data,
              type: request.what,
              status: "true",
            };
            resolve(response);
          } else {
            reject(response.data);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  makePostRequest: (request) => {
    Vue.prototype.$swal.close();
    var loading_html =
      '<div style="height:150px;width:150px;margin:0 auto;display:flex;align-items:center;justify-content:center;">' +
      '<div style="' +
      "width:60px;height:60px;" +
      "border:6px solid #ccc;" +
      "border-top:6px solid #F8A022;" +
      "border-radius:50%;" +
      "animation:spin 0.8s linear infinite;" +
      '"></div>' +
      "</div>" +
      "<style>" +
      "@keyframes spin {" +
      "to { transform: rotate(360deg); }" +
      "}" +
      "</style>";
    Vue.prototype.$swal.fire({
      title: "",
      html: loading_html,
      showConfirmButton: false,
      showCancelButton: false,
    });
    var request_urls = {
      Apply: "applyjobposting",
      UploadDocuments: "uploadapplicantdocument",
      ConfirmApplication: "confirmapplication",
    };
    if (request.params !== undefined) {
      var obj = request.params;
      var str = Object.keys(obj)
        .map((key) => {
          return key + "=" + obj[key];
        })
        .join("&");
      var request_url = URL + request_urls[request.what] + "?" + str;
    } else {
      var request_url = URL + request_urls[request.what];
    }
    if (request.url == undefined) {
      var request_url = URL + request_urls[request.what];
    } else {
      var request_url = request.url;
    }
    if (request.headers !== undefined) {
      var config = {
        headers: request.headers,
      };
      console.log(request.headers);
    } else {
      var config = {};
    }
    var data = request.data !== undefined ? request.data : "";
    console.log(
      "%cSending post request to: " + request_url,
      "color:#00ff00;font-size:14px;background:#000;",
    );
    console.log(data);
    return new Promise((resolve, reject) => {
      axios
        .post(request_url, data, config)
        .then((response) => {
          Vue.prototype.$swal.close();
          if (
            response.data.status == "True" ||
            response.data.status == true ||
            response.data.status == "true"
          ) {
            response = {
              data: response.data,
              type: request.what,
              status: "true",
            };

            resolve(response);
          } else {
            reject(response.data.message || "An unspecified error occured.");
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};
